import * as Yup from 'yup';
import { Box } from '@mui/material';
import { Button, FormSelectField, FormTextField, Grid } from 'ui';
import { Form, Formik } from 'formik';
import { JceHomepageGeographyTier } from 'generated/graphql';
import { TIER_LABELS, TIER_ORDER } from 'components/jceGeographyDetail/tierDefinitions';
import React from 'react';

export interface JceHomepageGeographyFormValues {
  name: string;
  urlSlug: string;
  resyBlogKey: string;
  tier: JceHomepageGeographyTier;
  priorityWithinTier: number;
}

export const DEFAULT_GEOGRAPHY_FORM_VALUES: JceHomepageGeographyFormValues = {
  name: '',
  urlSlug: '',
  resyBlogKey: '',
  tier: 'TIER_THREE',
  priorityWithinTier: 0,
};

export const geographyFormSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  urlSlug: Yup.string().required('URL slug is required'),
  resyBlogKey: Yup.string().required('resy blog key is required'),
  tier: Yup.string().required('Tier is required'),
  priorityWithinTier: Yup.number().integer().required('Priority is required'),
});

interface JceGeographyAttributesFormProps {
  initialValues: JceHomepageGeographyFormValues;
  onSubmit: (values: JceHomepageGeographyFormValues) => Promise<void>;
  submitLabel: string;
}

export const JceGeographyAttributesForm: React.FC<JceGeographyAttributesFormProps> = ({
  initialValues,
  onSubmit,
  submitLabel,
}) => (
  <Formik<JceHomepageGeographyFormValues>
    initialValues={initialValues}
    validationSchema={geographyFormSchema}
    onSubmit={onSubmit}
    enableReinitialize
  >
    {({ values, dirty, isValid, isSubmitting }) => (
      <Form>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} sx={{ mt: 1 }}>
            <FormTextField fullWidth label="Name" name="name" required />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ mt: 1 }}>
            <FormTextField fullWidth label="URL Slug" name="urlSlug" required />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormTextField fullWidth label="Resy Blog Key" name="resyBlogKey" required />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box sx={{ '& .MuiFormControl-root': { marginBottom: 0 } }}>
              <FormSelectField fullWidth label="Tier" name="tier" value={values.tier}>
                {TIER_ORDER.map((tier) => (
                  <option key={tier} value={tier}>
                    {TIER_LABELS[tier]}
                  </option>
                ))}
              </FormSelectField>
            </Box>
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormTextField
              fullWidth
              label="Priority Within Tier"
              name="priorityWithinTier"
              type="number"
              value={values.priorityWithinTier}
            />
          </Grid>
        </Grid>
        <Button
          color="primary"
          disabled={!dirty || !isValid || isSubmitting}
          size="large"
          type="submit"
          variant="contained"
          sx={{ mt: 3 }}
        >
          {submitLabel}
        </Button>
      </Form>
    )}
  </Formik>
);
